import { ToolAllowancePayload } from "../models/tool-allowance.model";

export class LoadToolAllowance {
  public static readonly type = "[Tool Allowance] load steady tool allowances";
}

export class AddToolAllowance {
  public static readonly type = "[Tool Allowance] add steady tool allowance";
  constructor(
    public payload: ToolAllowancePayload,
    public callbackSuccess: () => void,
    public callbackError: (error) => void
  ) {}
}

export class UpdateToolAllowance {
  public static readonly type = "[Tool Allowance] update steady tool allowance";
  constructor(
    public payload: ToolAllowancePayload,
    public callbackSuccess: () => void,
    public callbackError: (error) => void
  ) {}
}

export class RemoveToolAllowance {
  public static readonly type = "[Tool Allowance] remove steady tool allowance";
  constructor(
    public id: string,
    public callbackSuccess: () => void,
    public callbackError: () => void
  ) {}
}
